"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.MonitorSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var MonitorSVG = function MonitorSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("path", {
    stroke: "none",
    d: "M2 21a2 2 0 002 2h9v3h-3a1 1 0 000 2h12a1 1 0 000-2h-3v-3h9a2 2 0 001.1-.3 2.3 2.3 0 00.6-.6A2 2 0 0030 21v-2H2zM29.7 4.9a2.3 2.3 0 00-.6-.6A2 2 0 0028 4H4a2 2 0 00-2 2v11h28V6a2 2 0 00-.3-1.1z"
  }));
};
exports.MonitorSVG = MonitorSVG;
MonitorSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(MonitorSVG);
exports.default = _default;